export const paymentConfig = {
  paymentConfig: "Approve Topup",
  depositAccount: "บัญชีฝาก",
  withdrawAccount: "บัญชีถอน",
  save: "บันทึก",
  cancel: "ยกเลิก",
  disableWithdraw: "ปิดการถอน",
  disableDeposit: "ปิดการฝาก",
  deposit:"การฝาก",
  withdraw:"การถอน",
  open: "เปิด",
  close: "ปิด",
};
